import React, { useState } from "react";
import axios from "axios";
import {
  Container,
  Card,
  CardBody,
  Button,
  Spinner
} from "reactstrap";

import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "../Assets/css/style.css";

const StartInterview = () => {

  const [loading, setLoading] = useState(false);

  const token = localStorage.getItem("token");

  const startInterview = async () => {

    setLoading(true);

    try {

      const res = await axios.post(
        // "http://localhost/qads_interview/interview/start.php",
        "https://interview.qads.co.in/qads_interview/interview/start.php",
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
          }
        }
      );

      toast.success(res.data.message);

      setTimeout(() => {
        window.location.href = "/question";
      }, 1200);

    } catch (err) {

      toast.error(
        err.response?.data?.message || "Failed to start interview"
      );

    }

    setLoading(false);
  };

  return (
    <div className="interview-wrapper">
      <ToastContainer />

      <Container className="text-center">
        <Card className="interview-card shadow">
          <CardBody>

            <h3 className="mb-4 text-white">
              Ready to Start Interview?
            </h3>

            <p className="text-white">
              Duration : 30 Minutes | Questions will be loaded automatically
            </p>

            <Button
              className="start-btn"
              onClick={startInterview}
              disabled={loading}
            >
              {loading ? (
                <>
                  <Spinner size="sm" /> Starting...
                </>
              ) : (
                "Start Interview"
              )}
            </Button>

          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default StartInterview;